export const FUNDS_TRANSFER_ROLES = ['owner']
export const PAYMENT_ROLES = ['owner', 'manager']
